<template>
  <HScaffold title="账户明细">
    <template #header>
      <div :style="{
        backgroundColor:HNewGameUIConfig.newGameUIType === 3?'#1f1f1f':'white',
        padding: '10px',
        borderBottom: HNewGameUIConfig.newGameUIType === 3?'#2a2a2a 1px solid':'#f6f6f6 1px solid',
      }">
        <HDatePicker :change="selectDateChange"/>
        <DoubleTags :initTagId="initTagId" :change="selectTagChange" style="margin-top: 10px" reqPath="/app/wallet/flow-tag"
                    :startSecs="requestStartSecs" :endSecs="requestEndSecs"/>
      </div>
    </template>
    <HList path="/app/wallet/flow-list" :exParams="requestExParams">
      <template #default="{ item }">
        <div class="eachBlockDiv" :style="{
          borderBottom: HNewGameUIConfig.newGameUIType === 3?'#333 1px solid':'#f6f6f6 1px solid',
          backgroundColor: HNewGameUIConfig.newGameUIType === 3?'#1f1f1f':'white',
        }">
          <div style="display: flex;flex-direction: row;align-items: center;">
            <HCacheImage :src="item['IconUrl']" height="30px"/>
            <div :style="[
              hcf.getTextStyle({
            marginLeft:10,addSize:-1,
          }),
          {
            width:'85px',
            textAlign: 'center',
          }
          ]">
              {{item["Name"]}}
            </div>
            <div style="background-color: #ccc;height:28px;border-radius:3px;width:1px;margin: 0 10px;"/>
            <div style="width:100%;display: inline-flex;flex-direction: column;margin-right: 6px;">
              <div style="display:inline-flex;flex-direction:row;align-items: center;justify-content: space-between;">
                <div :style="hcf.getTextStyle({
                  addSize:-1,
              })">{{item["MidDes"] === "" && item["Name"] === "充值"?"默认支付渠道":item["MidDes"]}}</div>
                <div :style="hcf.getTextStyle({

              })">{{hcf.getMoneyValue(item["ChangeBalance"])}}</div>
              </div>
              <div style="display: flex;flex-direction:row;align-items: center;justify-content: space-between;">
                <div :style="hcf.getTextStyle({
                addSize:-2,color:'#aaa'
              })">{{hcf.getDateByMillSecs(item["MidTime"],2)}}</div>
                <HCountdownTimer
                    v-if='getChangeDesTextAndColor(item)["text"] === "未付款"'
                    frontStr="等待到账:"
                    :countdownSecs='getCountDownSecs(item)'
                    countdownColor="#fa1818"
                    :countdownFontSizeAdd="-3"
                    margin="0"
                    :isShowHour="false"
                >
                  <div v-if='item["CsUrl"]!==""' @click="openService(item)" style="background-color: var(--ct-main-color);border-radius: 3px;padding:2px 5px;">
                    <div :style="hcf.getTextStyle({
                     color:'white',addSize:-3
                  })">
                      联系客服
                    </div>
                  </div>
                  <div v-if='item["CsUrl"]===""' :style="hcf.getTextStyle({
                  addSize:-2,color:getChangeDesTextAndColor(item)['color']
                })">{{getChangeDesTextAndColor(item)["text"]}}</div>
                </HCountdownTimer>
                <div v-if='getChangeDesTextAndColor(item)["text"]  !== "未付款"' :style="hcf.getTextStyle({
                addSize:-2,color:getChangeDesTextAndColor(item)['color']
              })">{{getChangeDesTextAndColor(item)["text"]}}</div>
              </div>
            </div>
          </div>
          <div v-if="item['CanExpend']" style="display:flex;flex-direction: column;">
            <div style="margin-top:2px;display:flex;flex-direction: row;justify-content: space-between">
              <div v-if='item["TimeCreate"]!==0' style="display:flex;flex-direction: row;">
                <div :style="hcf.getTextStyle({
                addSize:-1,color:'#999'
              })">创建时间:</div>
                <div :style="hcf.getTextStyle({
                color:'#777',marginLeft:5,addSize:-1
              })">{{hcf.getDateByMillSecs(item["TimeCreate"],2)}}</div>
              </div>
              <div v-if='item["TimeFinish"]!==0' style="display:flex;flex-direction: row;">
                <div :style="hcf.getTextStyle({
                addSize:-1,color:'#999'
              })">到账时间:</div>
                <div :style="hcf.getTextStyle({
                color:'#777',marginLeft:5,addSize:-1
              })">{{hcf.getDateByMillSecs(item["TimeFinish"],2)}}</div>
              </div>
            </div>
            <div v-if='item["OrderId"] !== ""'  @click="()=>{hcf.copyClipboard(item['OrderId']);}" style="margin-top:2px;display:flex;flex-direction: row;">
              <div style="display:flex;flex-direction: row;">
                <div :style="hcf.getTextStyle({
                  addSize:-1,color:'#999'
                })">订单编号:</div>
                <div :style="hcf.getTextStyle({
                  color:'#777',marginLeft:5,addSize:-1
                })">{{item["OrderId"]}}</div>
              </div>
              <div :style="{
                borderRadius:'3px',
                backgroundColor: HNewGameUIConfig.newGameUIType === 3?'#111':'#eaeaea',
                padding: '1px 3px',
                marginLeft:'5px',
              }">
                <div :style="hcf.getTextStyle({
                  color:'main',addSize:-3
                })">复制</div>
              </div>
            </div>
            <div v-if='item["ExternInfo"] !== ""' style="margin-top:2px;display:flex;flex-direction: row;">
              <div style="display:flex;flex-direction: row;">
                <div :style="hcf.getTextStyle({
                addSize:-1,color:'#999'
              })">其他信息:</div>
                <div :style="hcf.getTextStyle({
                color:'#777',marginLeft:5,addSize:-1
              })">{{item["ExternInfo"]}}</div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </HList>
  </HScaffold>
</template>


<script setup>
  import HScaffold from "@/components/utils/HScaffold.vue";
  import HDatePicker from "@/components/utils/HDatePicker.vue";
  import DoubleTags from "@/components/pages/BetHisAndDetail/DoubleTags.vue";
  import HList from "@/components/utils/HList.vue";
  import {useUserStore} from "@/stores/useUser.js";
  import HCacheImage from "@/components/utils/HCacheImage.vue";
  import {hcf, log} from "@/components/utils/HComFunctions.js";
  import {hr} from "@/components/utils/HRouter.js";
  import HCountdownTimer from "@/components/utils/HCountdownTimer.vue";
  import HNewGameUIConfig from "@/components/utils/HNewGameUIConfig.js";

  const useUser = useUserStore();
  const { nowSecs, nDaysAgoSecs } = hcf.getNowAndNDaysAgoStart();
  const requestStartSecs = ref(nDaysAgoSecs);
  const requestEndSecs = ref(nowSecs);

  let selectTagItem1 = null;
  let selectTagItem2 = null;
  let initTagId = ref(null);
  const requestExParams = ref({});

  const props = hr.getRouteParams();
  if(props!=null){
    if(props["fromType"] === 1){
      let tempSelectTagItem = {
        "Id":1,
      };
      selectTagItem1 = tempSelectTagItem;
      initTagId.value = 1;
    }else if (props["fromType"] === 2) {
      let tempSelectTagItem = {
        "Id":4,
      };
      selectTagItem1 = tempSelectTagItem;
      initTagId.value = 4;
    }
  }

  function getChangeDesTextAndColor(item){
    let changeDes = item["ChangeDes"];
    let array = changeDes.split('#');
    if(array.length>=2){
      return {
        text:array[0],
        color:`#${array[1].slice(2, array[1].length)}`,
      }
    }else{
      return {
        text:changeDes,
        color:"#999",
      }
    }
  }

  updateExParams();

  function getCountDownSecs(item){
    let resultSecs = (Math.floor(item["TimeCreate"]) + item["CountDown"]) - Math.floor(Date.now()/1000)
    if(resultSecs<=0){
      return 0;
    }else{
      return resultSecs;
    }
  }

  function openService(item){
    hcf.launchUrl(item["CsUrl"]);
  }

  function selectDateChange(startSecs, endSecs) {
    requestStartSecs.value = startSecs;
    requestEndSecs.value = endSecs;
    updateExParams();
  }

  function selectTagChange(tagItem1, tagItem2) {
    selectTagItem1 = tagItem1;
    selectTagItem2 = tagItem2;
    updateExParams();
  }

  function updateExParams() {
    requestExParams.value = {
      "UserId": useUser.userId,
      "BeginTime": requestStartSecs.value,
      "EndTime": requestEndSecs.value,
      "Tag1": selectTagItem1!=null?[selectTagItem1["Id"]]:[],
      "Tag2": selectTagItem2!=null?[selectTagItem2["Id"]]:[],
      "Tag3": [],
    };
  }

</script>


<style scoped>
  .eachBlockDiv{
    display: flex;flex-direction: column;
    padding: 4px 10px;
  }

</style>
